@if (canShowButton()) {
  <div class="app-round-button-mv" data-cy="grid-engine-call-to-action-cell" fxLayoutAlign="center center">
    @let ctActions = actions();
    @if (ctActions?.length === 1 && ctActions[0]?.displaySingleAction) {
      <grid-engine-call-to-action-menu-item
        (actionClicked)="onActionClicked($event)"
        [action]="ctActions[0]"
        [element]="params().data"
        [userPermissions]="$safeNavigationMigration(params()?.userPermissions)"
      />
    } @else {
      <button (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu" mat-icon-button>
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @for (action of ctActions; track $index) {
          <grid-engine-call-to-action-menu-item
            (actionClicked)="onActionClicked($event)"
            [action]="action"
            [element]="params().data"
            [userPermissions]="$safeNavigationMigration(params()?.userPermissions)"
          />
        }
      </mat-menu>
    }
  </div>
}
